import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/demo/page.tsx");
